import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function CouponIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M20 13V9H4C3.44772 9 3 9.44772 3 10V18C3 18.5523 3.44641 19 3.9987 19C8.63096 19 15.5 19 15.5 19" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M21.4981 13.8666C20.335 12.4234 18.0885 12.864 17.5 14.5881C16.9115 12.8639 14.665 12.4233 13.5019 13.8665C12.048 15.6705 13.8653 18.196 17.5 20C21.1346 18.196 22.952 15.6706 21.4981 13.8666Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 5C6 4.44772 6.44772 4 7 4H18C19.1046 4 20 4.89543 20 6V9H6V5Z" stroke={color} strokeWidth="2"/>
        </svg>
    );
}

export default CouponIcon;
